export * from '@kaidam/fc-shared/src/frontend/store/utils/api'
import * as upstream from '@kaidam/fc-shared/src/frontend/store/utils/api'

import {
  IQuery_Project_Org,
} from '@kaidam/fc-shared/src/types/utils'

import {
  getProjectUrl as getProjectUrlUpstream,
} from '@kaidam/fc-shared/src/utils/url'

import {
  GetState,
} from '../../types/store'

import {
  currentProjectId,
  currentOrgId,
} from '../selectors/project'

export const getProjectInfo = (getState: GetState): IQuery_Project_Org => {
  const projectId = currentProjectId(getState())
  if(!projectId) throw new Error(`cannot get project info when there is no project`)
  const orgId = currentOrgId(getState())
  if(!orgId) throw new Error(`cannot get project info when there is no org`)
  return {
    project: projectId,
    org: orgId,
  }
}

export const getProjectUrl = (getState: GetState) => {
  const {
    project,
  } = getProjectInfo(getState)
  return getProjectUrlUpstream(project)
}

export const getProjectHandlers = (getState: GetState, includeOrg = true) => {
  const {
    org,
  } = getProjectInfo(getState)
  const url = getProjectUrl(getState)
  return upstream.getHandlers(url, includeOrg ? {
    org,
  } : undefined)  
}